<template lang="html">
  <div>
    <v-bottom-sheet
      v-model="LocationDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
    <v-overlay :value="progress">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <!-- show location -->
    <v-card v-if="showMap">
      <v-layout row wrap justify-start align-center class="pa-5">
        <v-col
          cols="2"
          justify="start"
          align="start"
          class="pl-0 pr-0 pt-0 pb-0"
          @click="closeDialog"
        >
          <v-icon class="fz-30">mdi-close</v-icon>
        </v-col>
        <v-col
          cols="8"
          justify="center"
          align="center"
          class="pa-0"
        >
          <span class="tab-title" v-if="LocationDetail.file_name">{{LocationDetail.file_name}}</span>
          <span class="tab-title" v-else>{{$t('ChatSide.location')}}</span>
        </v-col>
        <v-col
          cols="2"
          justify="center"
          align="center"
          class="pr-0 pl-0 pt-0 pb-0"
          >
        </v-col>
      </v-layout>
      <v-divider class="mt-4 mb-2"></v-divider>
      <v-layout row wrap justify-start align-center class="pt-0 pl-5 pr-5 pb-3">
        <GmapMap
          :language="$i18n.locale"
          :center="{lat: lat, lng: lng}"
          :options="{fullscreenControl: true, content: ''}"
          :zoom="zoomMarker"
          style="width: 100%; height: 100vh; margin-top: 10px;"
        >
          <GmapMarker
            v-if="showMarker"
            :position="{lat: lat, lng: lng}"
            :options="{icon: pins.self}"
          >
          </GmapMarker>
        </GmapMap>
      </v-layout>
    </v-card>
    <!-- send location -->
      <v-card :style="stylechat" class="pa-2" v-else>
        <v-layout row wrap justify-start align-center class="pa-5">
          <v-col
            cols="2"
            justify="start"
            align="start"
            class="pl-0 pr-0 pt-0 pb-0"
            @click="closeDialog"
          >
            <v-icon class="fz-30">mdi-close</v-icon>
          </v-col>
          <v-col
            cols="8"
            justify="center"
            align="center"
            class="pa-0"
          >
            <span class="tab-title">{{$t('Dialog.map.header')}}</span>
          </v-col>
          <v-col
            cols="2"
            justify="center"
            align="center"
            class="pr-0 pl-0 pt-0 pb-0"
            >
            <span :class="(lat & lng) !== '' ? 'icon-color' : 'icon-color-edit'" @click="sendLocation()">{{$t('AnswerQuestion.ok')}}</span>
          </v-col>
        </v-layout>
        <v-divider class="mt-4 mb-2"></v-divider>
        <v-layout row wrap justify-start align-center class="pt-5 pl-5 pr-5 pb-3">
          <vue-google-autocomplete
            ref="address"
            id="map"
            classname="form-control"
            class="form-control-style"
            :placeholder="$t('Dialog.map.searching')"
            v-on:placechanged="getAddressData"
            :country="[$i18n.locale]"
          >
          </vue-google-autocomplete>
        </v-layout>
        <v-layout row wrap justify-start align-start class="pl-5 pr-5 pb-5 mt-0">
          <GmapMap
            :language="$i18n.locale"
            :center="{lat: lat, lng: lng}"
            :options="{fullscreenControl: true, content: ''}"
            :zoom="zoomMarker"
            style="width: 100%; height: 85vh; margin-top: 10px;"
            @click="updateCoordinates"
          >
            <GmapMarker
              v-if="showMarker"
              :position="{lat: lat, lng: lng}"
              :options="{icon: pins.self}"
              :draggable="true"
              @drag="updateCoordinates"
            >
            </GmapMarker>
          </GmapMap>
        </v-layout>
      </v-card>
    </v-bottom-sheet>
    <ErrorDialog :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail" @closeAlertDialog="closeAlertDialog"/>
    <WarningDialog :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning" @closeAlertDialog="closeAlertDialog"/>
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import WarningDialog from '@/components/Alert/Warning'
import ErrorDialog from '@/components/Alert/Error'
var _ = require('lodash')
export default {
  props: {
    LocationDialog: Boolean,
    LocationDetail: {}
  },
  data() {
    return {
      showMap: false,
      address: '',
      lat: 0,
      lng: 0,
      coordinates: null,
      pins: {
        pinaed: 'data:image/png;base64,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',
        self: 'data:image/png;base64,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'
      },
      showMarker: true,
      zoomMarker: 17,
      contact_select: '',
      publicPath: process.env.VUE_APP_BASE_PATH,
      selected: [],
      FriendList: [],
      ErrorDialogDetail: {},
      ErrorDialog: false,
      WarningDialogDetail: {},
      WarningDialog: false,
      data_user: {},
      edit_member: false,
      member_active: [],
      member_pending: [],
      progress: false,
      search: '',
      place_name: '',
      stylechat: {
        "--Location-HeaderColor": "white",
        "--Location-TabBackground": "white",
        "--Location-Icon": "gray",
        "--Location-IconActive": "#2662ae",
        "--Location-Background": "white",
        "--Location-FontSize": "18px",
        "--Location-FontSize-Title": "24px",
        "--Location-FontColor": "back",
        "--Location-FontSize-Status": "16px",
        "--Location-FontColor-Status": "grey",
        "--Location-Background-Input": "#E2E1E3",
        "--Location-Color-Button": "#EFF2FE",
        "--Location-FontColor-Button": "#2662ae",
        "--Location-FontColor-Block-Button": "#cb1002",
        "--Location-FontColor-Dis-Button": "#e2e1e3",
        "--Location-Btn-Confirm-Background": "#2662ae",
        "--Location-Btn-Confirm-Color": "white",
        "--Location-Btn-Confirm-FontSize": "18px",
        "--Location-Btn-Cancel-Background": "white",
        "--Location-Btn-Cancel-Color": "#2662ae",
        "--Location-Btn-Cancel-FontSize": "18px",
        "--Location-Btn-Leave-Background": "white",
        "--Location-Btn-Leave-Color": "#ff5252",
        "--Location-Btn-Leave-FontSize": "18px"
      },
    }
  },
  components: {
    WarningDialog,
    ErrorDialog,
    VueGoogleAutocomplete
  },
  computed: {
  },
  mounted() {
    // To demonstrate functionality of exposed component functions
    // Here we make focus on the user input
    // this.$refs.address.focus();
  },
  watch: {
    LocationDialog () {
      if (this.LocationDialog) {
        // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
        var user_profile = ''
        if (JSON.parse(this.$cookie.get('user-profile') == null)) {
          user_profile = JSON.parse(localStorage.getItem('user-profile'))
        } else {
          user_profile = JSON.parse(this.$cookie.get('user-profile'))
        }
        this.data_user = user_profile['account']['profile']
        if (this.LocationDetail !== '') {
          this.showMap = true
          // console.log(this.LocationDetail)
          this.lat = parseFloat(this.LocationDetail.message.split(',')[0])
          this.lng = parseFloat(this.LocationDetail.message.split(',')[1])
          // console.log(this.lat)
          // console.log(this.lng)
          this.progress = false
        } else {
          this.showMap = false
          this.getCurrentLocation()
        }
      }
    },
  },
  created () {
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    // this.data_user = user_profile['account']['profile']
    // this.getCurrentLocation()
  },
  methods: {
    getAddressData (addressData, placeResultData, id) {
      // console.log(placeResultData)
      this.address = addressData
      // console.log(this.address)
      this.lat = this.address.latitude
      this.lng = this.address.longitude
      this.place_name = placeResultData.name
    },
    getCurrentLocation () {
      this.progress = true
      // if (window.navigator.geolocation) {
      //   window.navigator.geolocation.getCurrentPosition((position) => {
      //     // console.log(position)
      //     this.progress = false
      //     this.lat = position.coords.latitude
      //     this.lng = position.coords.longitude
      //   })
      // } else {
      //   this.lat = ''
      //   this.lng = ''
      // }
      if (window.confirm("Allow this app to access your location?")) {
      // window.navigator.geolocation.getCurrentPosition((position) => {
      //   this.progress = false;
      //   this.lat = position.coords.latitude;
      //   this.lng = position.coords.longitude;
      //   console.log(`lat local => ${this.lat}`);
      //   console.log(`lng local => ${this.lng}`);
      // });
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const lat = position.coords.latitude;
            const lon = position.coords.longitude;

            // ใช้ Google Maps Geocoding API
            // const apiKey = "AIzaSyBUh61FWG3kr4BSAEO_NRrniSz8S5ceLic";
            // const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&key=${apiKey}`;

            const apiKey = "AIzaSyBUh61FWG3kr4BSAEO_NRrniSz8S5ceLic";
            const language = this.$i18n.locale !== undefined ? this.$i18n.locale : 'th'; // ภาษาไทย
            const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&language=${language}&key=${apiKey}`;
            
            fetch(url)
              .then((response) => response.json())
              .then((data) => {
                if (data.results.length > 0) {
                  this.progress = false;
                  // console.log("สถานที่:", data.results[0]);
                  this.lat = position.coords.latitude;
                  this.lng = position.coords.longitude;
                  this.place_name = data.results[0].formatted_address;
                } else {
                  console.log("ไม่พบข้อมูลสถานที่");
                  this.lat = position.coords.latitude;
                  this.lng = position.coords.longitude;
                  this.place_name = "";
                }
              })
              .catch((error) => console.error("Error:", error));
          },
          (error) => {
            console.error("Error getting location:", error);
          }
        );
      } else {
        this.lat = "";
        this.lng = "";
      }
    },
    updateCoordinates (location) {
      // console.log(location)
      this.coordinates = {
          lat: location.latLng.lat(),
          lng: location.latLn.lng(),
      };
      // console.log(this.coordinates)
      this.lat = this.coordinates.lat
      this.lng = this.coordinates.lng
      this.updatePlaceName(this.lat, this.lng)
    },
    updatePlaceName(lat, lng) {
      // ใช้ Google Maps Geocoding API
      // const apiKey = "AIzaSyBUh61FWG3kr4BSAEO_NRrniSz8S5ceLic";
      // const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

      const apiKey = "AIzaSyBUh61FWG3kr4BSAEO_NRrniSz8S5ceLic";
      const language = this.$i18n.locale !== undefined ? this.$i18n.locale : 'th'; // ภาษาไทย
      const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&language=${language}&key=${apiKey}`;

      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          if (data.results.length > 0) {
            this.progress = false;
            // console.log("สถานที่:", data.results[0].formatted_address);
            this.lat = lat;
            this.lng = lng;
            this.place_name = data.results[0].formatted_address;
          } else {
            console.log("ไม่พบข้อมูลสถานที่");
            this.lat = lat;
            this.lng = lng;
            this.place_name = "";
          }
        })
        .catch((error) => console.error("Error:", error));
    },
    sendLocation () {
      if ((this.lat & this.lng) !== '') {
        this.progress = true
        this.axios.post(process.env.VUE_APP_API_ALPINE + `/api/v1/pushLocation`, {
          tokenroom: this.$route.params.tokenroom,
          tokenuser: this.data_user.tokenuser,
          lat: this.lat.toString(),
          long: this.lng.toString(),
          address: this.place_name
        }).then((response) => {
          // console.log(response.data)
          if (response.data['status'] === 'success') {
            this.closeDialog()
          }
        }).catch(err => {
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        })
      }
    },
    closeAlertDialog (data) {
      if (data.type === 'warning') {
        this.WarningDialog = data.value
      } else if (data.type === 'err') {
        this.ErrorDialog = data.value
      }
    },
    emitWarning (item) {
      this.WarningDialog = false
      if (item.type === 'kickgroup') {
        this.kickGroup(item)
      } else if (item.type === 'cancelinvite') {
        this.cancelInvite(item)
      }
    },
    closeDialog() {
      this.address = null
      this.place_name = null
      this.lat = 0
      this.lng = 0
      // this.showMap = false
      if (!this.showMap) {
        this.showMap = false
        document.getElementById('map').value = ''
      } else {
        this.showMap = false
      }
      this.$emit('closeComponents', {
        name: 'sendlocation',
        value: false
      })
    },
  },
}
</script>

<style lang="css" scoped>
.form-control-style {
  height: 45px;
  border-style: solid;
  width: 100%;
  border-radius: 8px;
  background-color: #e2e1e3;
  border-color: #e2e1e3;
  padding: 10px;
}
.checkbox-color {
  color: var(--Location-IconActive) !important;
}
>>>.v-application .elevation-10 {
  box-shadow: none !important;
}
>>>.theme--light.v-sheet {
  box-shadow: none !important;
}
.list-overflow {
  height: calc(100vh - 120px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow::-webkit-scrollbar {
  width: 3px;
}

.list-overflow::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

.list-overflow-select {
  height: calc(100vh - 210px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}
.list-overflow-select::-webkit-scrollbar {
  width: 3px;
}

.list-overflow-select::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}
/* >>>.v-input__slot {
  background-color: var(--Location-Background-Input) !important;
  border-radius: 10px !important;
} */
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
  background-color: var(--Location-Background-Input) !important;
  border-radius: 10px !important;
}
>>>.v-dialog--fullscreen {
  border-radius: 0;
  margin: 0;
  height: 100%;
  position: fixed;
  /* overflow-y: auto; */
  top: 0;
  left: 0;
  overflow: hidden;
}
>>>.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.icon-color-edit {
  color: var(--Location-Icon) !important;
}
.icon-color {
  color: var(--Location-IconActive) !important;
}
.btn-confirm {
  background-color: var(--Location-Btn-Confirm-Background) !important;
  color: var(--Location-Btn-Confirm-Color) !important;
  font-size: var(--Location-Btn-Confirm-FontSize) !important;
  font-weight: 600;
}
.btn-cancel {
  background-color: var(--Location-Btn-Cancel-Background) !important;
  color: var(--Location-Btn-Cancel-Color) !important;
  font-size: var(--Location-Btn-Cancel-FontSize) !important;
  font-weight: 600;
}
.btn-leave {
  background-color: var(--Location-Btn-Leave-Background) !important;
  color: var(--Location-Btn-Leave-Color) !important;
  font-size: var(--Location-Btn-Leave-FontSize) !important;
  font-weight: 600;
}
.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}
.layout-page {
  /* height: calc(100vh - 64px) !important; */
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--Location-Background) !important;
}
.fz-30 {
  font-size: 30px;
}
.text-transform {
  text-transform: none;
}
.text-title {
  font-size: var(--Location-FontSize-Title) !important;
  color: var(--Location-FontColor) !important;
  font-weight: 600;
}
.tab-title {
  color: var(--Location-FontColor) !important;
  font-size: var(--Location-FontSize) !important;
  font-weight: 600;
}
.tab-title-status {
  color: var(--Location-FontColor-Status) !important;
  font-size: var(--Location-FontSize-Status) !important;
}
.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}
</style>
